import React from 'react';
import Avatar from 'react-avatar';

function Client({ username, className = "" }) {

  return (
    <div className={`d-flex align-items-center gap-2 ${className}`}>
      <Avatar name={username.toString()} size={42} round="12px" />
      <span className="text-truncate">{username.toString()}</span>
    </div>
  );
}

export default Client;
